import { withExtension } from 'components/Shared/DynamicForm'

const MaterialDynamicForm = ({DynamicForm, schema, orientation, onSubmit, defaultValues, disabledProperties, hiddenProperties, definitions }) => {

    return (
        withExtension(DynamicForm, { schema, orientation, onSubmit, defaultValues, disabledProperties, hiddenProperties, definitions })
    )

}

export default MaterialDynamicForm
